export function getFullPath(input: string): string {
    try {
        return new URL(input, global.window.document?.baseURI).href
    } catch (ex) {}
    return input
}
